<script>
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import MarketingsTable from "../components/marketingsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let marketingCountInstance = null;

  const mountMarketingCount = async () => {
    const module = await import("App/alaceMarketingActivities/count");
    const MarketingCount = module.default;

    if (el1) {
      marketingCountInstance = mountFederatedSvelteComponent(marketingCountInstance, MarketingCount, {
        target: el1,
      });
    }
  };

  void mountMarketingCount();

  onDestroy(() => {
    marketingCountInstance = destroySvelteComponentInstance(marketingCountInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <MarketingsTable />
    </div>
  </div>
</PageContainer>
